"use client"
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { ContactSchema } from "@/assets/schemas";
import style from '../../assets/styling/scss/contact.module.scss';
import { Input, TextArea, FormattedMessage } from "../elements";
import { globalStore } from "@/app/stores";

const ContactForm = () => {
  const { sendMessage } = globalStore;

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onBlur",
    resolver: zodResolver(ContactSchema),
  });

  const { register, handleSubmit, formState: { errors }, reset } = methods;


  const onSubmit = async (data) => {
    const response = await sendMessage(data);
    if (response) {
      reset();
    }
  };


  return (
    <form className={style.form} onSubmit={handleSubmit(onSubmit)}>
      <fieldset>
        <legend>
          <FormattedMessage id="contact_information" />
        </legend>
        <Input
          name={register("name")}
          labelId="contact_person"
          placeholderId="contact_person_placeholder"
          error={errors.name?.message}
        />
        <Input
          name={register("email")}
          labelId="email_address"
          placeholderId="email_address_placeholder"
          error={errors.email?.message}
        />
        <TextArea
          name={register("message")}
          labelId="message"
          placeholderId="message_placeholder"
          error={errors.message?.message}
          type="text-area"
          fullWidth={true}
        />
      </fieldset>

      <button type="submit" className={style.submitButton}>
        <FormattedMessage id="send_a_message" />
      </button>

    </form>
  )
}

export default ContactForm;

